import { ChartPosition, Rect } from '../util';
import { DrawPass } from './chart';

export function getAxisRect(position: ChartPosition, pass: DrawPass): Rect {
    switch (position) {
        case ChartPosition.top:
            return pass.viewState.topScaleArea;
        case ChartPosition.bottom:
            return pass.viewState.bottomScaleArea;
        case ChartPosition.left:
            return pass.viewState.leftScaleArea;
        case ChartPosition.right:
            return pass.viewState.rightScaleArea;
    }
}
